import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { usePrefs } from "@/lib/context";

let deferred = null;
const listeners = new Set();
window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; listeners.forEach((f) => f(true)); });
window.addEventListener("appinstalled", () => { deferred = null; listeners.forEach((f) => f(false)); });

export function InstallAppButton() {
  const { t } = usePrefs();
  const [can, setCan] = useState(!!deferred);
  useEffect(() => { listeners.add(setCan); return () => listeners.delete(setCan); }, []);
  if (!can) return null;
  const install = async () => {
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    if (outcome === "accepted") toast.success(t("installed"));
    deferred = null; setCan(false);
  };
  return (
    <button onClick={install} data-testid="install-app-button" title={t("installApp")}
      className="flex items-center gap-1.5 rounded-sm border border-[#B8860B] px-2 py-1.5 text-[11px] font-bold text-[#996515] transition-colors hover:bg-[#fdf8ec]">
      <Download size={13} /><span className="hidden sm:inline">{t("installApp")}</span>
    </button>
  );
}

export function OfflineBanner() {
  const { t } = usePrefs();
  const [off, setOff] = useState(!navigator.onLine);
  useEffect(() => {
    const on = () => setOff(false), offF = () => setOff(true);
    window.addEventListener("online", on); window.addEventListener("offline", offF);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", offF); };
  }, []);
  if (!off) return null;
  return <div className="bg-amber-100 px-4 py-1.5 text-center text-xs font-semibold text-amber-900" data-testid="offline-banner">{t("offline")}</div>;
}
